/**
 * Redirects the user to the provided URL.
 *
 * @param {string} url - The URL to redirect to.
 * @returns {void}
 */
export const handleLogoutRedirect = (url: string): void => {
  window.location.href = url
}
